import React from 'react';
import { Menu } from 'antd';

export const LCMenu = props => <Menu {...props} />;
